import {computed, ref} from 'vue'
import {useStore} from 'vuex'

import FilterControls from './FilterComponentControls.vue'
import SortingComponent from '../SortingComponent/SortingComponent.vue'


export default {
    name: "FilterComponentControls",
    components:{
        FilterControls,
        SortingComponent
    },
    props:{
        mobileDrawerContext:{
            default: false
        }
    },
    setup(props){
        const store = useStore()
        const facets = computed(()=>store.getters['productSearch/mainFacetsExcluded'])
        const mainFilterFacets = computed(()=>store.getters['productSearch/mainFilterFacets'])
        const selectedFacets = computed(()=>store.getters['productSearch/selectedFacetsOrdered'])
        const notInMobileDrawer = computed(()=>!props.mobileDrawerContext)
        const inMobileDrawer = computed(()=>props.mobileDrawerContext)
        const filterBarExpanded = computed(()=>store.state.productSearch.filterColumnVisible)
        const searchString = computed(()=>store.state.productSearch.search_string)

        const toggleMobileFilter = function(){
            const toggleState = store.state.main.mobile_drawer_component ? '' : 'FilterComponent'
            store.commit('main/set_mobile_drawer_component',toggleState)
        }

        const toggleFilterBar = function(){
            const toggleState = store.state.productSearch.filterColumnVisible
            store.commit('productSearch/toggleFilterColumnVisilibity', !(toggleState))
        }

        const selectFacet = function(group,facet){
            store.dispatch("productSearch/filterProducts",{
                group:group.name,
                facet:facet.name
            })
        }

        const getLabel = (labelRequested) => {
            return store.getters['labels/getLabel'](labelRequested)
        }

        const selectSearch = function(){
            store.commit('productSearch/set_search_string','')
            store.dispatch('productSearch/performSearch')
        }

        return {
            toggleMobileFilter,
            facets,
            getLabel,
            inMobileDrawer,
            notInMobileDrawer,
            mainFilterFacets,
            selectFacet,
            selectedFacets,
            toggleFilterBar,
            filterBarExpanded,
            searchString,
            selectSearch
        }
    }
}